import { useAuth0 } from '@auth0/auth0-react';
import { useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Button from 'react-bootstrap/Button';
import Nav from 'react-bootstrap/Nav';
import { getUserPermissions, isAuthorized, hasTenant } from '../utils/Permissions';
import { TENANT_INVESTCEO } from '../utils/constants';
import { NavDropdown } from 'react-bootstrap';
import { determineTenant } from '../utils/tenants';
import { Link } from 'react-router-dom';

export const Header = () => {

    const { loginWithRedirect, logout, isAuthenticated, getAccessTokenSilently, user } = useAuth0();
    const [permissionsLoaded, setPermissionsLoaded] = useState(false);

    useEffect(() => {
        const loadPermissions = async () => {
            if (isAuthenticated && user && user.sub) {
                const token = await getAccessTokenSilently();
                const userId = user.sub.split('|')[1];
                await getUserPermissions(token, userId);
                setPermissionsLoaded(true);
            }
        };
        loadPermissions();
    }, [isAuthenticated, user]);
    const username = user && user.name ? user.name : '';

    const LoginButton = () => {
        return (
            <Button
                variant="outline-success"
                onClick={() => loginWithRedirect({
                    appState: {
                        returnTo: window.location.pathname
                    }
                })}
            >
                Login
            </Button>
        );
    };

    const LogoutButton = () => {
        return (
            <Button
                variant="outline-success"
                onClick={
                    () => logout({
                        logoutParams: {
                            returnTo: window.location.origin,
                            clientId: process.env.REACT_APP_IAM_CLIENT_ID
                        }
                    })
                }
            >
                Log Out
            </Button>
        );
    };

    return (
        <div>
            <Navbar collapseOnSelect expand="lg" className="bg-body-tertiary">
                <Container>
                    {
                        determineTenant() === 'investceo' &&
                        <Navbar.Brand as={Link} to="/trade">InvestCEO</Navbar.Brand>
                    }
                    {
                        determineTenant() === 'alm' &&
                        <Navbar.Brand as={Link} to="/trade">ALM Trading</Navbar.Brand>
                    }
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav variant="tabs" className="me-auto">
                            {permissionsLoaded && isAuthorized('connectionScreen') && (
                                <Nav.Item>
                                    <Nav.Link as={Link} to="/connect">Connect</Nav.Link>
                                </Nav.Item>
                            )}
                            {permissionsLoaded && isAuthorized('tradeScreen') && (
                                <Nav.Item>
                                    <Nav.Link as={Link} to="/trade">Trade</Nav.Link>
                                </Nav.Item>
                            )}
                            {permissionsLoaded && isAuthorized('connectionScreen') && hasTenant(TENANT_INVESTCEO) && (
                                <Nav.Item>
                                    <Nav.Link as={Link} to="/performance">Performance</Nav.Link>
                                </Nav.Item>
                            )}
                            {permissionsLoaded && isAuthorized('admin') && (
                                <Nav.Item>
                                    <Nav.Link as={Link} to="/metrics">Metrics</Nav.Link>
                                </Nav.Item>
                            )}
                            {permissionsLoaded && isAuthorized('admin') && (
                                <Nav.Item>
                                    <Nav.Link as={Link} to="/admin">Admin</Nav.Link>
                                </Nav.Item>
                            )}
                        </Nav>
                        <Nav>
                            {
                                isAuthenticated && (
                                    <NavDropdown title={username} id="basic-nav-dropdown">
                                        <NavDropdown.Item><LogoutButton /></NavDropdown.Item>
                                    </NavDropdown>
                                )
                            }
                            {
                                !isAuthenticated && (
                                    <LoginButton />
                                )
                            }
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </div>
    )
}

